import styled from 'styled-components';

const Form = styled.form``;

const SearchForm = ({ onSubmit, children }) => {
	return <Form onSubmit={onSubmit}>{children}</Form>;
};

export default SearchForm;
